import { useAuthStore } from '@/services/stores/authStore';

// oxlint-disable-next-line typescript/explicit-module-boundary-types
const apply = (el: HTMLElement, binding: { value?: readonly string[] }): void => {
    if (!binding.value) {
        return;
    }

    // hasRole already checks for admin & station admin
    el.hidden = !useAuthStore().hasRole(binding.value);
};

const RoleDirective = {
    mounted: apply,
    updated: apply
};

export default RoleDirective;
